import { style } from "typestyle";
import { CommonStyles } from "./commonInfra/styles/CommonStyles";


// overriding styles specifically for the OmniboxComponent
export const overallStyles = style({
    $nest: {
        '.tb-omnibox': {
            $nest: {
                '&.for-serp': {
                    width: 560,
                    $nest: {
                        '.tb-omnibox-search-box': {
                            $nest: {
                                '.search': {
                                    width: '100%',
                                    $nest: {
                                        'input#search-omnibox': {
                                            width: 562,
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
            }
        }
    }
});

export const popupOverallStyles = style({
    backgroundColor: '#fff',
    backgroundClip: 'padding-box',
    boxShadow: '0 7px 15px rgb(0 0 0 / 20%)',
    width: '560px',

    $nest: {
        'a': {
            textDecoration: 'none',
            cursor: 'pointer',
            outline: '0',
            color: CommonStyles.Colors.Grey102,
            fontSize: CommonStyles.Sizes.NormalFontSize

        },
        '.tb-quicklinks-section-divider': {
            borderTop: '1px solid #e6e6e6',
        },
        '.tb-quicklinks-row': {
            display: 'table',
            margin: '4px 0 0 0',
            width: '100%',
            alignItems: 'stretch',

        },
        '.tb-quicklinks-highlight': {
            textAlign: 'center',
            display: 'inline-block',
            width: '75px',
            padding: '14px 15px 10px 15px',
            margin: '0',
            color: '#666',
            verticalAlign: 'top',
            height: '100%',
            $nest: {
                '&:hover,&:focus': {
                    backgroundColor: CommonStyles.Colors.Grey245,
                    color: CommonStyles.Colors.Grey102,
                    textDecoration: 'none',
                },
                '&.activeSectionItem': {
                    backgroundColor: CommonStyles.Colors.BlueHighlight
                }
            }
        },
        '.tb-quicklinks-highlight-border': {
            border: '1px solid #bfbfbf',
            borderRadius: '50%',
            margin: 'auto',
            height: '40px',
            width: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    }
});